"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var WalletIcon = function WalletIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.3335 10.8101H15.0002V12.5234H13.3335V10.8101Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6627 5.82813L16.6665 5.83334C17.5857 5.83334 18.3332 6.58084 18.3332 7.5V15.8333C18.3332 16.7525 17.5857 17.5 16.6665 17.5H4.1665C3.1615 17.5 1.6665 16.8342 1.6665 15V5C1.6665 3.62167 2.78817 2.5 4.1665 2.5H14.9998L15.8332 2.5C16.2935 2.5 16.6665 2.87309 16.6665 3.33334C16.6665 3.77124 16.3287 4.13025 15.8995 4.16407H13V4.16667H4.1665C3.7065 4.16667 3.33317 4.54084 3.33317 5C3.33317 5.45917 3.7065 5.83334 4.1665 5.83334H14.9998V5.82813H16.6627ZM4.1765 15.8333H16.6665V7.5H4.1665C3.87234 7.5 3.59484 7.44 3.33317 7.34584V15C3.33317 15.6708 3.7915 15.8233 4.1765 15.8333Z",
    fill: color
  }));
};

var _default = WalletIcon;
exports.default = _default;